
import { FirebaseData } from "../General/FirebaseData";
import { LocalData } from "../General/LocalData";
import { PropertyData } from "../Property/PropertyData";

export class CompanyModuleData extends FirebaseData {
  active: boolean = false;
  allProperties: boolean = false;
  selectedProperties: PropertyData[] = [];

  setup(data: any) {
    this.active = typeof data.active === "boolean" ? data.active : false;
    this.allProperties = typeof data.allProperties === "boolean" ? data.allProperties : false;
    this.selectedProperties = []
    if (Array.isArray(data.selectedProperties)) {
      this.selectedProperties = data.selectedProperties.map((p: string) => LocalData.properties.addData(p));
    }
    super.setup(data);
  }
}